<template>
  <basic-layout-dynamic>
    <div class="container">
      <div class="contents">
        <div class="filter">
          <div class="file">
            <div class="file-name">
              <font-awesome-icon
                class="icon icon-with-text"
                icon="file-alt"
              ></font-awesome-icon>
              <a href="#" @click.prevent="$refs.file.click()">
                {{ filename }}
              </a>
            </div>
            <input
              hidden
              ref="file"
              type="file"
              multiple
              @change="setFiles($event.target.files)"
            />
          </div>
          <div class="actions">
            <div gl-tooltip="分析開始" gl-tooltip-direction="down">
              <gl-button
                primary
                @click="search"
                :disabled="!canSearch"
                icon-pre="search"
                icon-button
              ></gl-button>
            </div>
            <div
              gl-tooltip="CSVダウンロード"
              gl-tooltip-direction="down"
              v-if="completedSteps.finish"
            >
              <gl-button primary icon-button @click="csvDownload">
                <md-icon> <font-awesome-icon icon="file-csv"/></md-icon>
              </gl-button>
            </div>
          </div>
        </div>

        <!-- 結果 -->
        <div class="table-container" v-if="completedSteps.finish">
          <div v-if="zipFountExceedsLimit" class="message-max-count-exceeds">
            分析結果上位{{
              maxSearchCount
            }}件を表示しています。すべてのデータ見たい場合はCSVダウンロードしてください
          </div>

          <md-table v-model="_zips" md-card class="table" :disabled="true">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="郵便番号" class="label-name">
                {{ item.zip }}
              </md-table-cell>
              <md-table-cell md-label="住所" class="label-name">
                {{ item.address }}
              </md-table-cell>
              <md-table-cell md-label="ID数" class="customer-count">
                {{ item.customerCount | formatNumeric('0,0') }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <!-- 進捗ダイアログ -->
      <md-dialog
        :md-active.sync="downloading"
        :md-click-outside-to-close="false"
        :md-close-on-esc="false"
      >
        <md-dialog-content>
          <md-steppers
            md-alternative
            md-linear
            md-vertical
            :md-active-step.sync="activeStep"
          >
            <md-step
              id="uploading"
              md-label="Upload"
              :md-editable="false"
              :md-done.sync="completedSteps.uploading"
            >
              <p v-if="!invalidFile">
                顧客ファイルをアップロードしています
                <md-progress-bar md-mode="indeterminate"></md-progress-bar>
              </p>
              <p v-else>
                <span class="warn"
                  >顧客一覧ファイルが読み込めませんでした。</span
                >
              </p>
            </md-step>
            <md-step
              id="calculating"
              md-label="Calculate"
              :md-editable="false"
              :md-done.sync="completedSteps.calculating"
            >
              <p v-if="!noData">
                対象顧客を計算しています
                <md-progress-bar md-mode="indeterminate" />
              </p>
              <p v-else>
                <span class="warn">対象データがありませんでした！</span>
              </p>
            </md-step>
          </md-steppers>
        </md-dialog-content>
        <md-dialog-actions v-if="canCloseDialog">
          <gl-button @click="downloading = false">Close</gl-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </basic-layout-dynamic>
</template>

<script>
import download from '@/util/download'

/**
 * 郵便番号集計
 *
 * 顧客コード一覧ファイルを選択し、その顧客を郵便番号より住所一覧を表示する機能を提供します。
 */
export default {
  props: {},
  data() {
    return {
      single: undefined,
      file: undefined,
      zips: [],
      activeStep: 'uploading',
      completedSteps: {
        uploading: false,
        calculating: false,
        finish: false,
      },
      downloading: false,
      downloadLink: undefined,
      noData: false,
      invalidFile: false,
      maxSearchCount: 100,
      customerZipSearchCount: 0,
    }
  },
  computed: {
    filename() {
      return this.file ? this.file.name : 'ファイルを選択してください'
    },
    canSearch() {
      if (!this.file) {
        return false
      }
      return true
    },
    canDownload() {
      if (!this.file) {
        return false
      }
      if (this.downloading) {
        return false
      }

      return true
    },
    canCloseDialog() {
      return this.activeStep === 'finish' || this.invalidFile || this.noData
    },
    zipFountExceedsLimit() {
      return this.customerZipSearchCount > this.maxSearchCount
    },
    _zips() {
      return this.zips.slice(0, this.maxSearchCount)
    },
  },
  methods: {
    async setFiles(files) {
      if (files.length === 0) {
        return
      }
      this.file = files[0]
    },
    async search() {
      this.downloading = true
      this.invalidFile = false
      this.noData = false
      this.completedSteps.uploading = false
      this.completedSteps.calculating = false
      this.completedSteps.finish = false
      this.activeStep = 'uploading'
      this.customerZipSearchCount = 0
      this.zips = []

      // Upload
      const result = await this.$customerGroup.upload(this.file)
      if (result.invalidFile) {
        this.invalidFile = true
        return
      }
      this.completedSteps.uploading = true

      // Calculate
      this.activeStep = 'calculating'

      this.zips = await this.$repositories
        .get('customerZipGroup')
        .get(result.customerGroupId)
      this.customerZipSearchCount = this.zips.length
      this.completedSteps.calculating = true

      if (this.zips.length === 0) {
        this.noData = true
        return
      }

      this.completedSteps.finish = true
      this.activeStep = 'finish'
      this.downloading = false
    },
    csvDownload() {
      //ヘッダ部
      let csv = ['郵便番号', '住所', 'ID数'].join(',') + '\n'

      //データ部
      this.zips.forEach(zip => {
        csv += Object.values(zip).join(',')
        csv += '\n'
      })

      var bom = new Uint8Array([0xef, 0xbb, 0xbf]) //BOM
      var blob = new Blob([bom, csv], { type: 'text/csv' })

      download(blob, 'zips.csv')
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.filter {
  align-items: center;
  display: flex;
  flex-direction: row;
}
.actions {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-left: var(--spacing-large);
}
.contents {
  width: auto;
  max-width: 1000px;
  padding-top: var(--spacing-large);
  padding-bottom: var(--spacing-large);
}
.file-name {
  font-size: 1.3rem;

  .icon {
    color: #00b0ff;
    margin-right: var(--spacing-small);
  }
}
.md-table-row {
  .customer-count {
    text-align: right;
  }
}
</style>
